import PropTypes from 'prop-types';
import CustomField from '../../../../components/forms/dynamic-form-inputs/custom-fields/custom-field';
import { useDynamicFormContext } from '@evertrue/sdk';

// probably belongs in the SDK
// The challenge with putting this in the SDK is that each custom component is defined in et-parts, which is not a dependency of the SDK.
// so we need to create new components in the SDK (use MUI inputs) and then put this in the SDK.
const DynamicCustomField = ({
  formValues = {},
  fieldValue,
  handleChange = () => {},
  handleTouched = () => {},
  customField = {},
  error = null,
  touched = false,
}) => {
  const { evaluateRulesForField } = useDynamicFormContext();
  const fieldName = `custom_field.${customField.id}`;
  const state = evaluateRulesForField(fieldName, formValues);

  return (
    <>
      {state === 'hidden' ? null : (
        <>
          <CustomField
            name={fieldName}
            value={fieldValue}
            required={state === 'required'}
            handleChange={handleChange}
            customField={customField}
            handleTouched={handleTouched}
          />
          {touched && error && <div className="formik-field-error">{error}</div>}
        </>
      )}
    </>
  );
};

DynamicCustomField.propTypes = {
  formValues: PropTypes.object,
  fieldValue: PropTypes.any,
  handleChange: PropTypes.func.isRequired,
  handleTouched: PropTypes.func,
  customField: PropTypes.shape({
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    dataType: PropTypes.string.isRequired,
    required: PropTypes.bool,
    uiControlType: PropTypes.string,
  }).isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
};

export default DynamicCustomField;
